import { useI18n } from "@/lib/i18n";

const monograms = ["M", "H", "C", "G", "V", "B"];

export default function Partners() {
  const { t } = useI18n();

  return (
    <section className="py-16 lg:py-20 border-t border-border bg-background">
      <div className="mx-auto max-w-container px-6 lg:px-10">
        <div className="max-w-[680px] mx-auto text-center">
          <p className="text-[11px] tracking-[0.22em] uppercase text-primary/70">
            {t.home.partnersEyebrow}
          </p>
          <h2 className="mt-3 font-serif text-[42px] lg:text-[48px] font-normal leading-[1.12] tracking-tight text-foreground">
            {t.home.partnersTitle}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
            {t.home.partnersBody}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {monograms.map((monogram, i) => (
            <div
              key={monogram}
              className="reveal group rounded-lg border border-border bg-card p-8 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="mx-auto w-16 h-16 rounded-full border-2 border-primary/40 flex items-center justify-center">
                <span className="font-serif text-2xl font-normal text-primary">{monogram}</span>
              </div>
              <p className="mt-5 text-sm text-muted-foreground">{t.home.countries[i]}</p>
              <p className="mt-2 text-[15px] text-foreground">{t.home.partnerDescriptions[i]}</p>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-sm text-muted-foreground">
          {t.home.partnersNote}
        </p>
      </div>
    </section>
  );
}
